import React from 'react';

const formatCurrency = (val) => `₹${parseFloat(val || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const StatCard = ({ title, amount, subtitle, icon, colorClass, bgColorClass, textColorClass, isNegative }) => (
    <div style={{
        background: '#fff', borderRadius: '8px', padding: '16px', 
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        display: 'flex', flexDirection: 'column', gap: '8px',
        border: '1px solid #f1f5f9', position: 'relative',
        borderBottom: `2px solid ${colorClass}`
    }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ fontSize: '16px', fontWeight: '700', color: isNegative ? '#ef4444' : '#1e293b' }}>
                {isNegative && amount > 0 ? '-' : ''}{formatCurrency(amount)}
            </div>
            <div style={{ color: colorClass }}>
                {icon}
            </div>
        </div>
        <div style={{ fontSize: '12px', fontWeight: '500', color: '#64748b' }}>
            {title}
        </div>
    </div>
);

export default StatCard;
